// src/hooks/use-internal-translate.ts
import * as React from "react";
import { useTranslate } from "@refinedev/core";
var useInternalTranslate = () => {
  const translate = useTranslate();
  return React.useCallback(
    (key, {
      fallback,
      ns = "core",
      data = {}
    }) => translate(key, { ns, ...data }, fallback),
    [translate]
  );
};

// src/translations/core.json
var core_default = {
  pages: {
    list: {
      pageSize: "{{numOfPage}} / page",
      prevPage: "Previous page",
      nextPage: "Next page",
      search: "Search",
      appliedFilter_one: "Applied filter",
      appliedFilter_other: "Applied filters",
      lastUpdatedAt: "Last updated at {{time}}",
      multipleToggle: "Select multiple"
    },
    show: {
      field: "FIELD",
      value: "VALUE",
      image: "Image"
    },
    forgotPassword: {
      success: "You will receive the instruction to reset password shortly!"
    },
    updatePassword: {
      success: "Password updated."
    }
  },
  actions: {
    changeLanguage: "Change language",
    add: "Add",
    getNotification: "Keep me notified of change",
    stopNotification: "Stop notification",
    editSection: "Edit {{section}}"
  },
  messages: {
    noFound: "No found",
    accessDenied: "Access denied",
    noPermissionToVisitPage: "You have no permission to visit this page",
    dataMaybeOutdated: "Data may be outdated as we fail to get latest data",
    dataUpdateSuccess: "Data updated successfully",
    deleteResourceConfirmation: "This action is undoable. Do you want to proceed?",
    noData: "No data",
    noDataWithFilter: "For enhanced security, please utilize the filter/search field to ensure you are accessing only the relevant and authorized data within the table.",
    uploadedAt: "Uploaded at {{time}}",
    sectionUpdateSuccess: "{{section}} updated successfully"
  }
};

export {
  useInternalTranslate,
  core_default
};
//# sourceMappingURL=chunk-76Y5ZM74.mjs.map